import request from "@/utils/request"

// 获取更新日志已发布版本号
export const getIterationVersion = function(query) {
  return request('get', '/api/common/getIterationVersion', query)
}

// 列表
export const logList = function(query) {
  return request('get', '/api/iteration_log', query)
}

// 新增/编辑
export const addLog = function(query) {
  return request('get', '/api/zh_CN/iteration_log/save', query)
}

// 删除
export const deletLog = function(query) {
  return request('get', '/api/iteration_log/delete', query)
}

// 已读
export const readLog = function(params) {
  return request('post', '/api/iteration_log/read', params)
}

// 是否存在未读
export const isUnRead = function(query) {
  return request('get', '/api/iteration_log/isUnRead', query)
}
